import { render, staticRenderFns } from "./ed-homework-teacher-section-person-item.vue?vue&type=template&id=c28a2990&scoped=true&"
import script from "./ed-homework-teacher-section-person-item.ts?vue&type=script&lang=ts&"
export * from "./ed-homework-teacher-section-person-item.ts?vue&type=script&lang=ts&"
import style0 from "./ed-homework-teacher-section-person-item.scss?vue&type=style&index=0&id=c28a2990&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28a2990",
  null
  
)

export default component.exports